import { createAuthClient } from 'better-auth/react';
import { config } from '@/config/env';

export const authClient = createAuthClient({
  baseURL: config.apiUrl,
});

export function useAuth() {
  const { data, isPending, error, refetch } = authClient.useSession();

  const isAuthenticated = !!data?.session;

  return {
    session: data?.session ?? null,
    user: data?.user ?? null,
    isPending,
    isAuthenticated,
    error,
    refetch,
    signIn: authClient.signIn,
    signOut: authClient.signOut,
  };
}

const errorMap: Record<string, string> = {
  USER_NOT_FOUND: 'User not found',
  FAILED_TO_CREATE_USER: 'Failed to create user account',
  FAILED_TO_CREATE_SESSION: 'Failed to create session',
  FAILED_TO_UPDATE_USER: 'Failed to update user information',
  FAILED_TO_GET_SESSION: 'Failed to retrieve session',
  INVALID_PASSWORD: 'Invalid password',
  INVALID_EMAIL: 'Invalid email address',
  INVALID_EMAIL_OR_PASSWORD: 'Invalid email or password',
  SOCIAL_ACCOUNT_ALREADY_LINKED: 'Social account is already linked to another user',
  PROVIDER_NOT_FOUND: 'Authentication provider not found',
  INVALID_TOKEN: 'Invalid authentication token',
  ID_TOKEN_NOT_SUPPORTED: 'ID token not supported',
  FAILED_TO_GET_USER_INFO: 'Failed to retrieve user information',
  USER_EMAIL_NOT_FOUND: 'User email not found',
  EMAIL_NOT_VERIFIED: 'Email address not verified',
  PASSWORD_TOO_SHORT: 'Password is too short',
  PASSWORD_TOO_LONG: 'Password is too long',
  USER_ALREADY_EXISTS: 'User already exists',
  EMAIL_CAN_NOT_BE_UPDATED: 'Email address cannot be updated',
  CREDENTIAL_ACCOUNT_NOT_FOUND: 'Credential account not found',
  SESSION_EXPIRED: 'Session has expired',
  FAILED_TO_UNLINK_LAST_ACCOUNT: 'Cannot unlink the last account',
  ACCOUNT_NOT_FOUND: 'Account not found',
  USER_ALREADY_HAS_PASSWORD: 'User already has a password',
  UNABLE_TO_CREATE_USER: 'Unable to create user',
};

export function getAuthErrorMessage(errorCode: string): string {
  const errorCodeUpper = errorCode.toUpperCase();
  if (errorCodeUpper in errorMap) {
    return errorMap[errorCodeUpper];
  }

  return 'An unexpected error occurred';
}
